import React, { useState } from "react";
import styles from "./ContactUsForm.module.scss";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Limit the message field to 5000 characters
    if (name === "message" && value.length > 5000) {
      setErrors({ ...errors, message: "Message cannot exceed 5000 characters" });
      return;
    } else {
      // Reset error on valid input
      setErrors({ ...errors, message: "" });
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.fullName) newErrors.fullName = "Name is required";
    if (!formData.message) newErrors.message = "Message is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      alert("Form submitted!");
      console.log(formData);
    }
  };

  return (
    <div className={styles.contactContainer}>
      <div className={styles.formSection}>
        <h2>Contact Form</h2>
        <p>You can contact us by filling out the form below to get information on the subject you want.</p>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <div className={styles.formGroup_inputgroup}>
            <input
              type="text"
              name="fullName"
              placeholder="Full name"
              value={formData.fullName}
              onChange={handleChange}
            />
            {errors.fullName && <span className={styles.error}>{errors.fullName}</span>}
            </div>
            <input
              type="text"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className={styles.formGroup}>
            <div className={styles.formGroup_inputgroup}>
            <input
              type="email"
              name="email"
              placeholder="E-mail"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <span className={styles.error}>{errors.email}</span>}
            </div>
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
            />
          </div>
          <div className={styles.formGroup}>
          <div className={styles.formGroup_inputgroup_textarea} >
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
            />
            {errors.message && <span className={styles.error}>{errors.message}</span>}
            </div>
          </div>
          <button type="submit">Send</button>
        </form>
      </div>

      <div className={styles.contactSection}>
        <h2>Contact Us</h2>
        <div>
          <p>
            <strong>Office:</strong>
            <br />
            SealKloud Infotech Pvt Ltd
            <br/>
            4th Floor,  ISR Towers Plot No-23,
            <br/>
            Municipal No.1-118/23, Madhapur,
            <br/>
            Rohini Layout, Hyderabad,
            <br/>
            Rangareddy, Telangana, 50008
            <br/>
            +91-9963500366
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
